module.exports = __webpack_public_path__ + "img/stage_enabled_5.95841827.png";